import { Heading } from '@planningcenter/tapestry-react';
import React from 'react';

const SUBHEADING_STYLES = {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "165%",
};
const Subheading = ({ children }) => (React.createElement(Heading, { level: 2, ...SUBHEADING_STYLES }, children));

export { SUBHEADING_STYLES, Subheading };
//# sourceMappingURL=subheading.js.map
